import {
  FormModalStyle,
  Close
} from "@/imports-files/components/common-modal/common-modal";

const FormModal = (props) => {
  const { className } = props;
  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal} ${props?.filterWidth && FormModalStyle.FilterModal} ${props?.jobFilterModal && `JobFilterModal`} ${props?.ScoreCardModal && FormModalStyle.ScoreCardModal}`}  >
        <div className={`${FormModalStyle.Modal__Container} ${props?.largeWidth && FormModalStyle.ModalLarge} ${props?.NoOuterPadding && FormModalStyle.NoOuterPadding} ${props?.kanbanFilterModal && `kanbanfitermodal`}`}>
          <div className={`${FormModalStyle.Modal__Container__Heading__Close} ${props?.ScoreCardModal && FormModalStyle.ScoreCardModal__Heading__Close}`}>
            {props?.heading && (
                <h1
                  className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}
                >
                  {props?.heading}
                </h1>
              )}
            <div
              className={`${FormModalStyle.Modal__Container__CloseSection} text-right`}
              onClick={() => {
                props?.closeModal();
              }}
            >
              <Close/>
            </div>
          </div>
          <div className={FormModalStyle.Modal__Container__ContentSection}>

            {props?.description && (
              <h1
                className={`${FormModalStyle.Modal__Container__ContentSection__Description}`}
              >
                {props?.description}
              </h1>
            )}
            {props?.content}
          </div>
        </div>
      </div>
    </div>
  );
};
export default FormModal;
